import React from 'react';
import { useChatManager } from './ChatManager';

type ChatManagerContextType = ReturnType<typeof useChatManager>;

export const ChatManagerContext = React.createContext<ChatManagerContextType | null>(null);

export const ChatManagerContextProvider: React.FC<{ children: React.ReactChild }> = ({
  children,
}) => {
  const context = useChatManager();
  return (
    <ChatManagerContext.Provider value={context}>
      {children}
    </ChatManagerContext.Provider>
  );
};
